import React, { useEffect, useRef, useState } from 'react';
import { Select, message } from 'antd';
import { LANGUAGES } from '../../../constants';
import { appLanguageVar } from '../../../graphql/cache';
import {
  useGetCurrentUserQuery,
  useUpdateCurrentUserLocaleMutation,
} from '../../../models/graphql';
import { StorageUtils, useTranslation } from '../../../utils';
import './LangueagePicker.scss';

interface ILanguagePickerProps {
  // Simple user object - just needs to exist to indicate user is logged in
  user?: { id?: string; email?: string } | null;
}

const LanguagePicker: React.FC<ILanguagePickerProps> = ({ user }) => {
  const [language, setLanguage] = useState('');
  const initializedRef = useRef(false);
  const translate = useTranslation();
  const customerId = StorageUtils.getCustomerId();
  const { data: currentUser, loading: currentUserLoading } = useGetCurrentUserQuery({
    skip: !customerId,
  });
  const [updateUserLocale, { loading: updateLoading }] = useUpdateCurrentUserLocaleMutation();

  // Only initialize language on first load, don't reset on subsequent locale changes
  useEffect(() => {
    if (initializedRef.current) return;

    const userLocale = currentUser?.getCurrentUser.locale || '';

    if (
      LANGUAGES.some((l) => {
        return l.key === userLocale;
      })
    ) {
      appLanguageVar(userLocale);
      setLanguage(userLocale);
      initializedRef.current = true;
    } else if (user) {
      onChangeLanguageHandler('nl');
      initializedRef.current = true;
    }
  }, [currentUser?.getCurrentUser.locale, user]);

  const onChangeLanguageHandler = async (lang: string) => {
    if (!user) {
      return;
    }

    const result = await updateUserLocale({
      variables: {
        locale: lang,
      },
    });

    if (result.data?.updateCurrentUserLocale) {
      appLanguageVar(lang);

      setLanguage(lang);

      return;
    }

    message.error(translate('errorOccured'));
  };

  return (
    <div className="lang-select-container">
      <Select
        className="lang-select mobile-select"
        loading={currentUserLoading}
        onChange={onChangeLanguageHandler}
        disabled={updateLoading || currentUserLoading}
        value={language || currentUser?.getCurrentUser.locale!}
      >
        {LANGUAGES.map((lang) => {
          return (
            <Select.Option key={lang.value} value={lang.key}>
              {lang.key.toUpperCase()}
            </Select.Option>
          );
        })}
      </Select>
    </div>
  );
};

export default LanguagePicker;
